import { Badge, Group, Stack, Text } from '@mantine/core'
import { EventObject } from '@/types/event'

type ObjectListProps = {
  objects: EventObject[]
}

export const ObjectList = ({ objects }: ObjectListProps) => {
  return (
    <Stack gap="sm">
      {objects.map((obj) => {
        const tags = obj.tags ?? []
        return (
          <Stack key={obj.object_id} gap={4}>
            <Text size="sm">
              {obj.object_id}. {obj.description}
            </Text>
            {tags.length > 0 && (
              <Group gap="xs">
                {tags.map((tag, tagIndex) => (
                  <Badge
                    key={`${tag}-${tagIndex}`}
                    size="sm"
                    variant="light"
                    color="gray"
                  >
                    {tag}
                  </Badge>
                ))}
              </Group>
            )}
          </Stack>
        )
      })}
    </Stack>
  )
}
